export default "__VITE_ASSET__BxaCdgRW__"